export const GEOLOCATION_CONFIG = {
  // NSF-39 quick fix: location is neither asked for, waited on, stored nor
  // checked, in any configuration. ponytail: global switch; the ordered fix
  // derives this per session from its steps' `gps` checks.
  ENABLED: false as boolean,
  TIMEOUT: 10000,
  // Accept a fix up to 30s old. MAX_AGE 0 forced the GPS hardware to produce a
  // brand-new one for each of the seven steps, which is where a Pixel 3 spent
  // ~1.7s per capture. The vehicle does not move between steps, so a fix that
  // recent records the same place.
  MAX_AGE: 30_000,
  ENABLE_HIGH_ACCURACY: true,
} as const;

export const CAMERA_CONFIG = {
  // In-page camera stream. Chromium's takePhoto() returns the sensor's photo
  // resolution whatever the stream size; the stream sizes the viewfinder and
  // the video-frame fallback, so ask for 4:3 inside the MIN..MAX box.
  IDEAL_WIDTH: 2560,
  IDEAL_HEIGHT: 1920,
  FACING_MODE: 'environment',
  // Only applies where we re-encode a still that is outside the MAX box.
  // 0.90 is visually indistinguishable from 0.95 on a photo but roughly
  // halves both the encode time and the upload.
  JPEG_QUALITY: 0.9,
  // A photo with an EXIF DateTimeOriginal is only accepted if it is this
  // close to the moment it came back from the camera. Firefox for Android
  // ignores <input capture> and offers the gallery too; this is what keeps
  // gallery photos out, since no attribute can remove that option.
  //
  // 3 minutes, not seconds: the window has to cover the whole time the user
  // spends inside the camera app, and that is theirs, not ours — framing the
  // VIN plate, waiting for focus, reviewing the shot before accepting it. A
  // tighter bound rejected honest photos on slow phones. It still keeps the
  // gallery out: anything picked from it was taken on an earlier visit.
  MAX_PHOTO_AGE_MS: 3 * 60_000,
} as const;

export const IMAGE_QUALITY_CONFIG = {
  MIN_WIDTH: 1600,
  MIN_HEIGHT: 1300,
  // boundNativePhoto never exceeds this box. iOS and low-memory devices use
  // a smaller one (see captureLimits); the dimensions check is the ceiling.
  MAX_WIDTH: 4000,
  MAX_HEIGHT: 3000,
  MIN_SHARPNESS: 5,
} as const;
